import LinkButton from "./Components/LinkButton";

const NissanCityToCity = () => {
  return (
    <div>
      <LinkButton to="/admin/wwl-nissan/nissan-pricing">View prices</LinkButton>
    </div>
  );
};

export default NissanCityToCity;
